import React from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import {
  SearchRounded,
  CheckRounded,
  DeleteOutlineRounded,
} from "@mui/icons-material";

/* ─────────────────────────────────────────────────────────
   SUNUCU KODU FİLTRESİ (aranabilir dropdown)
   ───────────────────────────────────────────────────────── */
export function ServerFilter({ value, options, onChange, accent }) {
  return (
    <Autocomplete
      size="small"
      disableClearable
      options={options}
      value={value}
      onChange={(_, v) => onChange(v || "Tümü")}
      sx={{
        mb: 0.75,
        "& .MuiAutocomplete-inputRoot": { py: 0.25 },
        "& .MuiAutocomplete-popupIndicator": { color: accent },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Sunucu kodu ara..."
          size="small"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <Box
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  pl: 0.5,
                  pr: 0.5,
                  color: accent,
                }}
              >
                <SearchRounded sx={{ fontSize: 15 }} />
              </Box>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#fff",
              borderRadius: 1.5,
              fontSize: 12.5,
              fontWeight: 600,
              color: "#1E293B",
              border: `1px solid ${accent}55`,
              transition: "border-color 0.2s ease, box-shadow 0.2s ease",
              "& fieldset": { border: "none" },
              "&:hover": {
                borderColor: `${accent}AA`,
                boxShadow: `0 0 0 3px ${accent}1A`,
              },
              "&.Mui-focused": {
                borderColor: accent,
                boxShadow: `0 0 0 3px ${accent}2E`,
              },
            },
            "& input": { py: 0.5 },
          }}
        />
      )}
    />
  );
}

/* ─────────────────────────────────────────────────────────
   TARİH ARALIĞI FİLTRESİ
   İki native <input type="date"> + uygula/temizle
   ───────────────────────────────────────────────────────── */
export function DateRangeFilter({
  start,
  end,
  active,
  onStartChange,
  onEndChange,
  onApply,
  onClear,
  accent,
}) {
  const canApply = !!start && !!end && !active;

  return (
    <Box
      sx={{
        mb: 0.75,
        p: 0.6,
        borderRadius: 1.5,
        backgroundColor: active ? `${accent}18` : "#fff",
        border: `1px solid ${active ? accent : `${accent}55`}`,
        display: "flex",
        gap: 0.5,
        alignItems: "center",
        transition: "background-color 0.2s ease, border-color 0.2s ease",
      }}
    >
      <TextField
        type="date"
        size="small"
        value={start || ""}
        onChange={(e) => onStartChange(e.target.value || null)}
        title="Başlangıç tarihi"
        sx={{
          flex: 1,
          minWidth: 0,
          "& .MuiOutlinedInput-root": {
            fontSize: 11.5,
            fontWeight: 600,
            color: "#1E293B",
            borderRadius: 1,
            "& fieldset": { borderColor: "#E2E8F0" },
            "&:hover fieldset": { borderColor: accent },
            "&.Mui-focused fieldset": { borderColor: accent },
          },
          "& input": {
            py: 0.5,
            px: 0.75,
            "&::-webkit-calendar-picker-indicator": {
              opacity: 0.55,
              cursor: "pointer",
            },
          },
        }}
      />

      <Box sx={{ color: "#94A3B8", fontSize: 11, fontWeight: 700 }}>–</Box>

      <TextField
        type="date"
        size="small"
        value={end || ""}
        onChange={(e) => onEndChange(e.target.value || null)}
        title="Bitiş tarihi"
        sx={{
          flex: 1,
          minWidth: 0,
          "& .MuiOutlinedInput-root": {
            fontSize: 11.5,
            fontWeight: 600,
            color: "#1E293B",
            borderRadius: 1,
            "& fieldset": { borderColor: "#E2E8F0" },
            "&:hover fieldset": { borderColor: accent },
            "&.Mui-focused fieldset": { borderColor: accent },
          },
          "& input": {
            py: 0.5,
            px: 0.75,
            "&::-webkit-calendar-picker-indicator": {
              opacity: 0.55,
              cursor: "pointer",
            },
          },
        }}
      />

      {active ? (
        <IconButton
          size="small"
          onClick={onClear}
          title="Temizle"
          sx={{
            p: 0.5,
            color: "#EF4444",
            transition: "transform 0.2s ease, background-color 0.2s ease",
            "&:hover": { backgroundColor: "#FEE2E2", transform: "scale(1.1)" },
            "&:active": { transform: "scale(0.9)" },
          }}
        >
          <DeleteOutlineRounded sx={{ fontSize: 16 }} />
        </IconButton>
      ) : (
        <IconButton
          size="small"
          onClick={onApply}
          disabled={!canApply}
          title="Uygula"
          sx={{
            p: 0.5,
            color: canApply ? "#22C55E" : "#CBD5E1",
            transition: "transform 0.2s ease, background-color 0.2s ease",
            "&:not(:disabled):hover": {
              backgroundColor: "#DCFCE7",
              transform: "scale(1.1)",
            },
            "&:not(:disabled):active": { transform: "scale(0.9)" },
          }}
        >
          <CheckRounded sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Box>
  );
}
